module.exports = __webpack_public_path__ + "ac02c582b291c19c52099cd74b31e0e3.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/15.png
// module id = 299
// module chunks = 0